export default {
  emailtemplates: [],
  pagination: {},
  emailtemplate: {},
  copiedTemplate: {}
}
